<template>
  <div class="staysItem">
    <div class="staysItem__ImageWrapper">
      <Flare v-if="accommodation?.gallery?.[0].image" :srcset="accommodation.gallery[0].image" size="both" width="644" height="470" crop="fill" :alt="accommodation.gallery[0].image" />
    </div>
    <div class="staysItem__ContentWrapper">
      <div>
        <div v-if="accommodation" class="staysItem__Location">
          <Icon name="location" /><span><template v-if="accommodation.place?.name">{{ accommodation.place.name }} /</template> <template v-if="accommodation.region?.name">{{ accommodation.region.name }}</template></span>
        </div>

        <h3 v-text="data.facility" />

        <div v-if="accommodation?.category_rating" class="staysItem__StarsWrapper">
          <Icon v-for="star in accommodation.category_rating" name="star" />
        </div>

        <div class="staysItem__Dates staysItem__InfosBlock">
          <h4 v-text="$t('stays.dates')" />
          <span><template v-if="data.arrival">{{ format(toZonedTime(new Date(data.arrival), 'Europe/Zagreb'), 'dd.MM.yyyy.', { timeZone: 'Europe/Zagreb' }) }}</template> <template v-if="data.departure">- {{ format(toZonedTime(new Date(data.departure), 'Europe/Zagreb'), 'dd.MM.yyyy.', { timeZone: 'Europe/Zagreb' }) }}</template></span>
        </div>
      </div>

      <div class="staysItem__Links">
        <Button @click="goToDetails" medium>{{ $t('stays.viewDetails') }}</Button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { format, toZonedTime } from 'date-fns-tz';
  const { initialData, link } = useSetup();

  const props = defineProps({
    data: {},
    past: {
      type: Boolean,
      default: false,
    }
  });

  const accommodation = computed(() => initialData.value?.accommodations?.find(item => item.phobs_id === props.data.phobs_id));

  async function goToDetails() {
    sessionStorage.setItem('reservationData', JSON.stringify(props.data));
    let query = { code: props.data?.phobs_code || '', pageId: accommodation?.value?.id || '' };
    if (props.past) query = { ...query, past: true };
    return await navigateTo({ path: link('StaysDetail'), query})
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_staysItem.scss');
</style>